import { Link } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { TiPrinter } from 'react-icons/ti';
import ROUTES from '../../../../core/constants/routes.constants';
import PortalLayout from '../../../../components/layouts/PortalLayout';

function HomeScene() {
  return (
    <PortalLayout>
      <Typography variant="h5" component="h2" align="left" py={2} paragraph>
        Welcome, Mark
      </Typography>

      <Grid py={2} container spacing={3}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Button
            variant="contained"
            color="primary"
            size="xl"
            fullWidth
            component={Link}
            to={ROUTES.portal}
            startIcon={<TiPrinter size={40} />}
          >
            Participants
          </Button>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Button
            variant="contained"
            color="primary"
            size="xl"
            fullWidth
            component={Link}
            to={ROUTES.portal}
            startIcon={<TiPrinter size={40} />}
          >
            Sites
          </Button>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Button
            variant="contained"
            color="primary"
            size="xl"
            fullWidth
            component={Link}
            to={ROUTES.portal}
            startIcon={<TiPrinter size={40} />}
          >
            Study Users
          </Button>
        </Grid>
      </Grid>
    </PortalLayout>
  );
}

export default HomeScene;
